let deferredInstallPrompt = null;

function isStandaloneMode() {
  return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
}

function isIosSafari() {
  const ua = window.navigator.userAgent || '';
  const isIos = /iPad|iPhone|iPod/.test(ua)
    || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
  const isWebKit = /WebKit/i.test(ua);
  const isOtherBrowser = /CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua);
  return isIos && isWebKit && !isOtherBrowser;
}

function showIosInstallHelp() {
  window.alert("Clique sur \"Partager\" puis sur \"Sur l'écran d'accueil\" pour installer l'app");
}

function showGenericInstallHelp() {
  window.alert("L'app n'est disponible que sur smartphone");
}

function getInstallButton() {
  return document.getElementById('pwaInstallBtn');
}

function setInstallButtonVisibility(visible) {
  const installBtn = getInstallButton();
  if (!installBtn) return;
  installBtn.hidden = !visible;
}

function setupInstallPrompt() {
  const installBtn = getInstallButton();
  if (!installBtn) return;

  setInstallButtonVisibility(!isStandaloneMode());

  installBtn.addEventListener('click', async () => {
    if (deferredInstallPrompt) {
      deferredInstallPrompt.prompt();
      try {
        await deferredInstallPrompt.userChoice;
      } catch {
        // Ignored by design; visibility is reset below.
      }
      deferredInstallPrompt = null;
      setInstallButtonVisibility(!isStandaloneMode());
      return;
    }

    if (isIosSafari()) {
      showIosInstallHelp();
      return;
    }

    showGenericInstallHelp();
  });

  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferredInstallPrompt = event;
    setInstallButtonVisibility(!isStandaloneMode());
  });

  window.addEventListener('appinstalled', () => {
    deferredInstallPrompt = null;
    setInstallButtonVisibility(false);
  });
}

function setupOfflineStatus() {
  window.addEventListener('offline', () => {
    document.body.classList.add('pwa-offline');
  });
  window.addEventListener('online', () => {
    document.body.classList.remove('pwa-offline');
  });
}

function registerPwa() {
  setupInstallPrompt();
  setupOfflineStatus();

  if (!('serviceWorker' in navigator)) return;
  if (!window.isSecureContext) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((error) => {
      console.warn('[PWA] Service worker registration failed:', error);
    });
  });
}

registerPwa();
